import React from 'react';  
import PB from '../assets/pb2.jpg'
import { motion } from "motion/react"
function CTA() { 
    return (
    <section id="cta"    className=" d-flex align-items-center ctapic" 
      style={{
        backgroundImage: `linear-gradient(
      180deg,
    rgba(0, 0, 0, 0.65),
      rgba(0, 0, 0, 0.65)
    ),url(${PB})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center top",
        maxHeight: "500px",
        width: "100%",
        borderTop: 'solid 2px white',
        borderBottom:'solid 2px white'
        // position: "relative",
        }}
       
    >
  <motion.div class="container text-center" initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{
    duration: 0.8,
    ease: "easeOut"
  }}
  viewport={{
    once: true,
    amount: 0.3
  }}>
    <h2 style={{fontFamily: 'Inter, sans-serif',fontSize:'clamp(1.5rem, 3vw, 2.5rem)', color:'white',fontWeight:'300', lineHeight:'1.1'}}>
      Interested in adding billboard assets to your investment portfolio? Review the offering details and learn how you can participate in the Fund’s opportunity.
    </h2>
    <p style={{color:'white',fontSize:'1rem', marginTop:'16px', maxWidth:'520px', marginLeft:'auto', marginRight:'auto', lineHeight:'1.7'}}>
      Join many other accredited investors who have already committed capital to the Boch Investment Fund LLC Regulation D Offering. Minimum investment of $100,000.
    </p>
                <a href="signup" class="btn-ink rounded" style={{ color: 'white', border:'solid 2px white', fontWeight:'600' }}>
      Invest Now
    </a>
     {/* <div style={{marginTop:'32px', color:'rgba(13,13,13,45)', fontSize:'.72rem', letterSpacing:'.08em'}}>
      All information in this offering is for qualified accredited investors only. Securities not registered under the Securities Act.
    </div>  */}
  </motion.div>
</section>
)

}

export default CTA;